import { render, staticRenderFns } from "./google2.vue?vue&type=template&id=ebb62218&"
import script from "./google2.vue?vue&type=script&lang=js&"
export * from "./google2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports